import PreviewPDF from "./PreviewPDF";
import func from "@uikit/func";
import { message, Progress } from "antd";
import { useEffect, useRef, useState } from "react";
import DragDropFile from "../../../../views/components/DragDropFile";
import LoadingOutline from "../../../../views/components/LoadingOutline";
import utilIndex from "../../../../views/thinking-layout-editor/utils";
import useDownloadMeta from "../../../../custom-hooks/useDownloadMeta";
import { FileOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { UploadFileProvider, useUploadFile } from "./uploadFileContainer";
import style from "./UploadFile.module.scss";

const audioTypes = ["mp3", "mp4", "m4a", "wav"];

export const fileType = (fileData: any) => {
  return fileData?.name?.split?.(".")?.[1] || "";
};
const isAudioType = (fileData: any) => {
  return audioTypes.includes(fileType(fileData));
};

const UploadFile: React.FC<any> = props => {
  const {
    uploadStatus,
    progressPercent,
    setProgressPercent,
    fileList,
    setFileList,
    fileExt,
    fetchDownloadMata,
    setPreviewState,
    fileStatus,
  } = useUploadFile({ onDownloadMata: onDownloadMataWithAudio, onUploaing });

  const { dropUploadFileData } = props;
  // const [uploadStatus, setUploadStatus] = useState('')
  const [audioPlayTime, setAudioPlayTime] = useState("");
  // const [progressPercent, setProgressPercent] = useState(0)

  const [playState, setPlayState] = useState(false);
  const [audioLoading, setAudioLoading] = useState(false);

  const audioRef = useRef<HTMLMediaElement>(null);

  const [downloadMetaData] = useDownloadMeta();

  const getTextNodeClass = () => {
    const classes = [
      `${style["custom-node"]} ${style["design-text"]}`,
      `${props.isLongPress || props.checkNodeArr.includes(props.id) ? "nowheel nopan" : ""}`,
    ];
    return classes.join(" ");
  };
  const onCanPlay = (e: any) => {
    const duration = e.target.duration;
    const sec = (duration % 60).toString().split(".")[0];
    const min = (duration / 60).toString().split(".")[0];
    setAudioPlayTime(`${min}:${sec}`);
  };
  const onTimeUpdate = (e: any) => {
    setProgressPercent((e.target.currentTime / e.target.duration) * 100);
  };
  const onEnded = () => {
    setPlayState(false);
  };
  const clickPlayAudio = () => {
    if (func.isEmpty(audioRef.current) || audioLoading) return;
    if (audioRef.current?.paused) {
      setPlayState(true);
      audioRef.current.play();
    } else {
      setPlayState(false);
      audioRef.current?.pause();
    }
  };

  // 本地预览 音频类型
  useEffect(() => {
    if (isAudioType(dropUploadFileData.fileData)) {
      if (dropUploadFileData.fileData) {
        const url = URL.createObjectURL(dropUploadFileData.fileData);
        URL.revokeObjectURL(dropUploadFileData.fileData);
        setPreviewState({ loading: false, previewURL: url });

        // if(isAudioType(dropUploadFileData.fileData)) {
        if (audioRef.current) {
          audioRef.current.src = url;
        }
        setAudioLoading(false);
        // }
      }
    }
  }, [fileStatus, dropUploadFileData]);

  function onUploaing(dropUploadFileData: any) {
    if (isAudioType(dropUploadFileData.fileData)) {
      setAudioLoading(true);
    }
  }

  function onDownloadMataWithAudio(tempVal: any, fileUrl: any) {
    // audio类型则下载资源
    if (isAudioType(tempVal)) {
      setAudioLoading(true);
      downloadMetaData(fileUrl)
        .then(url => {
          if (audioRef.current) {
            audioRef.current.src = url as string;
          }
        })
        .catch(error => {
          func.messageError(error);
        })
        .finally(() => {
          setAudioLoading(false);
        });
      return;
    }
    fetchDownloadMata(tempVal, fileUrl);
  }

  return (
    <div className={getTextNodeClass()}>
      <div className={style["uploadfile-inner"]}>
        <div className={`${style["text-content"]} ${props.isLongPress ? "nodrag" : ""}`}>
          {!func.isEmpty(fileList) ? (
            <>
              {/* audio类型显示 */}
              {isAudioType(fileList[0]) ? (
                <div className={style["audio-content"]}>
                  <div className={style["audio-topbox"]}>
                    {/* 播放按钮 */}
                    <div
                      className={`${style["audio-play"]} ${audioLoading ? style["disable-play"] : ""}`}
                      onClick={clickPlayAudio}
                    >
                      {playState ? (
                        <span className="iconfont icon-pause"></span>
                      ) : (
                        <span className="iconfont icon-play"></span>
                      )}
                    </div>
                    <div className={style["audio-info"]}>
                      <p>{fileList[0]?.name}</p>
                      {audioLoading && func.isEmpty(props.dropUploadFileData) ? (
                        <LoadingOutline className="uploadfile-playtime" size={17} />
                      ) : (
                        <p>{audioPlayTime}</p>
                      )}
                    </div>
                  </div>
                  {/* 进度 */}
                  <Progress percent={progressPercent} size="small" showInfo={false} strokeColor="#12192B" />
                  {/* 播放源 */}
                  <audio ref={audioRef} onCanPlay={onCanPlay} onTimeUpdate={onTimeUpdate} onEnded={onEnded}></audio>
                </div>
              ) : null}
              {fileExt === "pdf" ? <PreviewPDF /> : null}
              {/* 自定义loading条 */}
              <div className={style["upload-content"]}>
                <FileOutlined />
                <div className={style["upload-file-info"]}>
                  <p>{fileList[0]?.name}</p>
                  <p>{utilIndex.humanizeBytes(fileList[0]?.size)}</p>
                </div>
                <div className={style["upload-loading"]}>
                  {uploadStatus === "uploading" ? (
                    <LoadingOutline />
                  ) : (
                    <CheckCircleOutlined style={{ color: "green", fontSize: "20px" }} />
                  )}
                </div>
              </div>
            </>
          ) : null}
          {/* 拖拽上传区域 */}
          <div className={!func.isEmpty(fileList) ? style["hide-dragcp"] : ""}>
            <DragDropFile nodeId={props.id} fileList={fileList} setFileList={setFileList} />
          </div>
        </div>
      </div>
    </div>
  );
};

const UploadFileWrap: React.FC<any> = props => (
  <UploadFileProvider value={props}>
    <UploadFile {...props} />
  </UploadFileProvider>
);

export default UploadFileWrap;
